export default "__VITE_ASSET__93e97ae0__"